export default __webpack_public_path__ + "static/media/BodoniModa_10pt-Medium.4566d97b.ttf";